export const purple = '#722ED1';
export const blue = '#2F54EB';
export const skyblue = '#1890FF';
export const tangaroa = '#002140';
export const green = '#52C41A';
export const blackpearl = '#001529';
